<template>
<div v-if="dataLoaded">
    <table-page
        :client="client"
        @updated="getData"
        :warnings="warnings"
        :changelogs="changelogs"
        :hideTabs="true"
    >
        <fast-table
            :recordLabel="recordLabel"
            :sections="sections"
            :headers="headers"
            :data="tableData"
            :activeRowId="currentRowId"
            @click="currentRowId = $event.id"
        >
            <template v-slot:table-actions>
                <button class="btn btn-primary btn-collapse" id="addButton" @click="addModalOpen = true">
                    <i class="far fa-fw fa-plus"></i> <span class="btn-text">Add Collection</span>
                </button>
            </template>
        </fast-table>

        <add-modal
            v-if="addModalOpen"
            :client="client"
            @updated="$emit('updated'); getData()"
            @close="addModalOpen = false"
        />
    </table-page>

    <sidebar
        v-if="currentRowId"
        :client="client"
        :collection-id="currentRowId"
        @updated="getData"
        @close="currentRowId = null"
    >
    </sidebar>
</div>
</template>

<script>
import TablePageMixin from '@/mixins/TablePageMixin'
import FastTable from '@/components/FastTable'
import Sidebar from './components/PaygroupCollections/Sidebar'
import AddModal from './components/PaygroupCollections/AddModal'

export default {
    components: {FastTable, Sidebar, AddModal},
    mixins: [TablePageMixin],
    props: ['client'],
    computed: {
        currentRow() {
            return this.collections.find(x => (x.id == this.currentRowId))
        },
        sections() {
            return [
                {title: 'Active', defaultIsClosed: false, id: 'active', hasDateFilter: false},
                {title: 'Inactive', defaultIsClosed: true, id: 'inactive', hasDateFilter: false},
            ]
        },
        tableData() {
            const tableData = []

            const sections = [
                this.collections.filter(obj => obj.is_active),
                this.collections.filter(obj => !obj.is_active),
            ]

            sections.forEach((section, idx) => {
                const sectionData = []

                section.forEach(obj => {
                    sectionData.push({
                        id: obj.id,
                        object: obj,
                        cells: [
                            obj.name,
                            obj.paygroup_set.length,
                        ],
                    })
                })

                tableData.push(sectionData)
            })

            return tableData
        },
    },
    data() {
        return {
            collections: [],
            dataLoaded: false,
            currentRowId: null,
            recordLabel: "Pay group collections",
            headers: [
                {label: 'Name', classes: '', isSearchable: true, defaultSort: true},
                {label: 'Pay Groups', classes: '', isSearchable: false, isFilterable: false},
            ],
            addModalOpen: false,
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Settings / Pay Group Collections')
        this.getData()
    },
    methods: {
        getData() {
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/clients/${this.client.id}/settings/paygroup-collections`).then(resp => {
                this.dataLoaded = true
                this.collections = resp
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                if (errors.__status__ == 403) {
                    this.$bus.$emit('no-access')
                }
                else {
                    this.$bus.showError(errors.__all__)
                }
            })
        },
    },
}
</script>
